
export default {
    test: {
        apphotel: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/hotel/index.html#/detail?from=activity&innId=',
        mhotel: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&innId=',
        mhoteljj: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&_platform=jj&innId=',
        apphotellist: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellist: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellistjj: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&_platform=jj&',
        mcitylist: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
        mcitylistjj: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/search/index.html#/city?_platform=jj&from=activity&',
        appcitylist: 'http://wehoteltest-cloud.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
    },
    prod: {
        apphotel: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/detail?from=activity&innId=',
        mhotel: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&innId=',
        mhoteljj: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/detail?&from=activity&_platform=jj&innId=',
        apphotellist: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellist: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&',
        mhotellistjj: 'https://booking.bestwehotel.com/wehotelapp/hotel/index.html#/list?from=activity&_platform=jj&',
        mcitylist: 'https://booking.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
        mcitylistjj: 'https://booking.bestwehotel.com/wehotelapp/search/index.html#/city?_platform=jj&from=activity&',
        appcitylist: 'https://booking.bestwehotel.com/wehotelapp/search/index.html#/city?from=activity&',
    }
}



// WEBPACK FOOTER //
// ./src/urlconfig.js